import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame", "nextButton"];
  static values = {
    stepId: Number
  }

  connect() {
    // Écoute de l'événement de fin de chargement du turbo-frame
    this.frameTarget.addEventListener(
      "turbo:frame-load",
      this.onFrameLoad.bind(this)
    );
  }

  enableNextButton() {
    this.nextButtonTarget.disabled = false;
  }

  onFrameLoad(event) {
    const form = this.frameTarget.querySelector("form");
    if (form) {
      this.enableNextButton();
    }
  }
}
